import { ButtonHTMLAttributes } from 'react';
import styled from 'styled-components';

import { Checkmark } from 'shared/icons/Checkmark';
import { Stack } from 'shared/components/Stack';
import { Loader } from 'shared/components/Loader';
import { t } from 'localization/utils/t';

const TP = 'wants.components.WantButton';

export interface IWantButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  'data-qa'?: string;
  wanted: boolean;
  loading?: boolean;
}

export const WantButton = ({ wanted, loading, disabled, ...rest }: IWantButtonProps) => {
  return (
    <WantButton.Root data-qa="want_button" {...rest} disabled={disabled || loading}>
      <WantButton.Stack direction="row" spacing="4px">
        {loading ? (
          <WantButton.Loader />
        ) : (
          <>
            <span data-qa="want_text">{t(`${TP}.want`, 'Want')}</span>
            {wanted && <Checkmark color="currentcolor" />}
          </>
        )}
      </WantButton.Stack>
    </WantButton.Root>
  );
};

WantButton.Root = styled.button<{ disabled?: boolean }>`
  ${({ disabled }) => (disabled ? '' : 'cursor: pointer;')}
`;

WantButton.Loader = styled(Loader)`
  width: 2em;
`;

WantButton.Stack = styled(Stack)`
  align-items: center;
  min-height: 1em;
`;
